import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImtiazVerificationRoutingModule } from './imtiaz-verification-routing.module';
import { ChangePinVerifyComponent } from './change-pin-verify/change-pin-verify.component';


import { StructureSharedModule } from '../structure-shared/structure-shared.module';
import { SharedModule } from '../shared/shared.module';
import { WebcamModule } from 'ngx-webcam';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader();
};

import { NgxMaskModule, IConfig } from 'ngx-mask'

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ChangePinVerifyComponent
  ],
  imports: [
    CommonModule,
    StructureSharedModule,
    SharedModule,
    WebcamModule,
    NgxMaskModule.forChild(),
    NgxMaskModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    FormsModule, ReactiveFormsModule
    
  ]
})
export class ImtiazVerificationModule { }
